import React from 'react';

import { BrowserRouter } from 'react-router-dom';
import Router from './Router/index';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  return (
    <BrowserRouter>
      <Router />
      <ToastContainer />
    </BrowserRouter>
  );
};

export default App;
